import type {
	ComboBoxFilterChangeEvent,
	MultiSelectChangeEvent,
} from "@tql/ui-components-react/kendo/dropdowns";
import { Label } from "@tql/ui-components-react/kendo/labels";
import { MultiSelect } from "@tql/ui-components-react/tql/dropdowns";

import type { IdName } from "~/shared/schemas/commodity-schema.ts";
import type { Customer } from "~/shared/schemas/customer-schema.ts";

type CustomerSearchFilterProps = {
	readonly label: string;
	readonly placeholder: string;
	readonly data: Customer[] | IdName[];
	readonly value: IdName[];
	readonly loading?: boolean;
	readonly selectAll?: IdName;
	readonly onChange: (e: MultiSelectChangeEvent) => void;
	readonly onFilterChange: (e: ComboBoxFilterChangeEvent) => void;
};

export function CustomerSearchFilter({
	label,
	placeholder,
	data,
	value,
	loading,
	selectAll,
	onChange,
	onFilterChange,
}: CustomerSearchFilterProps) {
	return (
		<div className={"loads-customer-filter"}>
			<Label className={"k-form-label"}>{label}</Label>
			<div className={"loads-header-filter-search"}>
				<MultiSelect
					className={"user-filter-multiselect"}
					data={data}
					dataItemKey={"id"}
					filterable={true}
					loading={loading}
					noDataText={"No Results Found"}
					onChange={onChange}
					onFilterChange={onFilterChange}
					placeholder={placeholder}
					selectAll={selectAll}
					tagLimit={5}
					textField={"name"}
					value={value}
				/>
			</div>
		</div>
	);
}
